import React, { ReactNode } from "react";

import "./style.scss";
import { DynamicLink } from "app/links/DynamicLink/DynamicLink";

export enum BUTTON_TYPES {
    PRIMARY = 0,
    SECONDARY
}

export interface LargeButtonProps {
    children: ReactNode;
    arrow?: boolean;
    type?: BUTTON_TYPES;
    className?: string;
    id?: string;
    enabled?: boolean;
    href?: string;
    rel?: string;
    onClick?: React.MouseEventHandler;
}

/**
 * The large button grows in width as much as it can so make sure to place it into a limiting container.
 */
export const LargeButton = ({
    children,
    type,
    className,
    id,
    onClick,
    enabled = true,
    arrow = false,
    rel,
    href
}: LargeButtonProps) => {
    const classNames = ["largeButton"];

    if (type === BUTTON_TYPES.PRIMARY) {
        classNames.push("primary");
    }

    if (!enabled) {
        classNames.push("disabled");
    }

    if (arrow) {
        classNames.push("arrow");
    }

    if (className) {
        classNames.push(className);
    }

    if (href) {
        return (
            <DynamicLink href={href} id={id} rel={rel} className={classNames.join(" ")}>
                {children}
            </DynamicLink>
        );
    }

    return (
        <button id={id} className={classNames.join(" ")} onClick={onClick}>
            {children}
        </button>
    );
};
